import { Check } from 'lucide-react';

export const ServiceBenefits = () => (
<>
<h2 className="text-3xl font-bold text-red-500 mb-6 mt-12">
              Pourquoi Choisir Maître Diamma pour Votre Retour Affectif ?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-gray-900/60 p-6 rounded-xl border border-red-900/30">
                <Check className="w-8 h-8 text-green-500 mb-3" />
                <h3 className="text-xl font-bold text-white mb-2">20+ Ans d'Expérience</h3>
                <p className="text-gray-400">Sorcier vaudou héritier d'une longue lignée africaine</p>
              </div>
              <div className="bg-gray-900/60 p-6 rounded-xl border border-red-900/30">
                <Check className="w-8 h-8 text-green-500 mb-3" />
                <h3 className="text-xl font-bold text-white mb-2">97% de Réussite</h3>
                <p className="text-gray-400">Taux de réussite annoncé · 280 clients satisfaits</p>
              </div>
              <div className="bg-gray-900/60 p-6 rounded-xl border border-red-900/30">
                <Check className="w-8 h-8 text-green-500 mb-3" />
                <h3 className="text-xl font-bold text-white mb-2">Résultats Rapides</h3>
                <p className="text-gray-400">Premiers effets visibles annoncés sous 3 à 7 jours</p>
              </div>
              <div className="bg-gray-900/60 p-6 rounded-xl border border-red-900/30">
                <Check className="w-8 h-8 text-green-500 mb-3" />
                <h3 className="text-xl font-bold text-white mb-2">Discrétion Totale</h3>
                <p className="text-gray-400">Confidentialité absolue garantie</p>
              </div>
            </div>
</>
);
